export const FeatureFlags = [
    'malt-start-links',
    'amplitude-recording-for-freelancer-adding-exp-from-project',
    'client-instant-conversation',
    'client-instant-conversation-unlogged',
    'limit-number-of-instant-conversation-per-day',
    'profile-revamp',
    'profile-revamp-drawer',
    'profile-revamp-drawer-see-more',
    'amplitude-recording-for-profile-non-self-view',
    'amplitude-recording-for-profile-self-view',
    'amplitude-recording-for-profile-unloggued-view',
    'amplitude-recording-for-freelancer-signup',
    'enable-profile-page-cache',
    'group-profile-admin-buttons-together',
    'enable-willingness-to-travel-details',
    'advanced-search-refinement-criteria',
    'new-profile-open-graph-image',
    'workshop-ai-nantes-portfolio-revamp',
    'enable-micro-consulting-on-profile-section',
    'enable-micro-consulting-status-on-profile-page',
    'portfolio-revamp-v1',
    'enable-micro-consulting-booking',
    'profile-suggestion',
] as const;

export type FeatureFlag = (typeof FeatureFlags)[number];

export type FeatureContext = Record<FeatureFlag, boolean | undefined>;
